angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsVehicleCtrl", [
  "$scope", "$parse", "$stateParams", "$location", "$timeout", "$modal", "$controller", "$cookies", "ConfigService", "CustomerApplicationService", "HardSecuredService", "ApplicationService", "$filter", "$window", "$rootScope",
  ($scope, $parse, $stateParams, $location, $timeout, $modal, $controller, $cookies, ConfigService, CustomerApplicationService, HardSecuredService, ApplicationService, $filter, $window, $rootScope) ->

    $scope.page = "vehicle"

    $scope.$emit('customer_application:data', ApplicationService.data)
    angular.extend($scope, $controller('CustomerApplicationsMixinCtrl', {$scope: $scope, CustomerApplicationService: CustomerApplicationService, ApplicationService: ApplicationService}))

    $scope.trackVisit
      "customer_application:product_type": $scope.customer_application.product_type

    sufficientVehicleData = ->
      !!($scope.vehicle?.mileage && ($scope.vehicle?.vin || $scope.vehicle?.style))

    # TODO investigate if this is used - if it is,
    # probably needs to be changed to account for no-vin
    vehicleExists = ->
      !!($scope.vehicle && $scope.vehicle.vin && $scope.vehicle.year && $scope.vehicle.make && $scope.vehicle.model)

    vehicleChangedSinceLastLookup = ->
      return false if (!$scope.vehicle?.vin && !$scope.vehicle?.style) || !$scope.vehicle?.mileage
      return true if !$scope.vehicle_lookup?.vehicle

      vin_changed = $scope.vehicle_lookup.vehicle.vin != $scope.vehicle.vin
      mileage_changed = $scope.vehicle_lookup.vehicle.mileage != $scope.vehicle.mileage
      vin_changed || mileage_changed

    isInPoorCondition = ->
      $scope.vehicle.condition is 'poor'

    isFreeAndClear = ->
      $scope.vehicle.free_and_clear

    $scope.isAutoRefinance = ->
      $scope.customer_application.auto_refinance

    isAutoRefinanceEnabled = ->
      $scope.customer_application.auto_refinance_enabled

    performLookup = (callback) ->
      if sufficientVehicleData()
        $scope.vehicle_lookup = status: 'working'
        lookup_type = $scope.vehicle?.vin && 'vin' || 'no_vin'
        HardSecuredService.lookupVehicle($scope.vehicle).then (data) ->
          status = data.errors.length == 0 && 'success' || 'error'
          $scope.vehicle_lookup =
            vehicle: angular.copy data.vehicle
            errors: data.errors
            status: status
          $scope.vehicle = data.vehicle if data.vehicle
          setDropdownsForVehicle()
          callback() if callback
        , (error) ->
          $scope.vehicle_lookup = status: 'error', errors: ['Unable to find the vehicle']

    # This is necessary because the drilldown process may not have occurred
    # TODO replace this with Jason's next_drilldown implementation
    setDropdownsForVehicle = ->
      $scope.vehicle_makes  = [$scope.vehicle.make] if $scope.vehicle?.make
      $scope.vehicle_models = [$scope.vehicle.model] if $scope.vehicle?.model
      $scope.vehicle_series = [$scope.vehicle.series] if $scope.vehicle?.series
      $scope.vehicle_styles = [$scope.vehicle.style] if $scope.vehicle?.style

      unless $scope.vehicle?.vin
        payload = {}

        if $scope.vehicle?.year
          payload['year'] = $scope.vehicle.year
          if $scope.vehicle?.make
            payload['make'] = $scope.vehicle.make
            if $scope.vehicle?.model
              payload['model'] = $scope.vehicle.model
              if $scope.vehicle?.series || $scope.vehicle?.style
                payload['series'] = $scope.vehicle.series if $scope.vehicle?.series
                payload['style']  = $scope.vehicle.style if $scope.vehicle?.style

        unless _.isEmpty(payload)
          HardSecuredService.multi_drilldown(payload).then (vehicles) ->
            $scope.vehicle_makes  = vehicles['make'] unless _.isEmpty(vehicles['make'])
            $scope.vehicle_models = vehicles['model'] unless _.isEmpty(vehicles['model'])
            $scope.vehicle_series = vehicles['series'] unless _.isEmpty(vehicles['series'])
            $scope.vehicle_styles = vehicles['style'] unless _.isEmpty(vehicles['style'])

    showInsufficientCollateralModal = ->
      $modal.open(
        templateUrl: "/shared/v3/modals/insufficient_collateral.html"
        controller: [
            "$scope", "$modalInstance", "invalid_fields", ($scope, $modalInstance, invalid_fields) ->
              angular.extend $scope, invalid_fields
              $scope.cancel = -> $modalInstance.close 'cancel'
              $scope.retry  = -> $modalInstance.close 'retry'
          ]
        resolve:
          invalid_fields: ->
            condition: $scope.form.vehicle_condition.$invalid
            free_and_clear: $scope.form.vehicle_free_and_clear.$invalid
      ).result.then (reply) ->
        HardSecuredService.insufficientCollateralReply(reply).then ->
          switch reply
            when 'cancel'
              CustomerApplicationService.createLoadingModal()
              $rootScope.$broadcast 'customer_application:modal_message', "Loading..."
              $window.location.reload()
            when 'retry'
              $scope.vehicle = null
              $scope.vehicle_lookup = null
              $scope.form.$setPristine()

    showAutoRefinanceModal = ->
      $modal.open
        openedClass: 'test-autorefi-modal-opened-class'
        windowTopClass: 'test-window-top-class'
        windowClass: 'test-autorefi-modal-class'
        templateUrl: '/shared/v3/modals/auto_refinance.html'
        scope: $scope
        controller: ['$scope', '$modalInstance', ($scope, $modalInstance) ->
          $scope.loading = false
          $scope.accept = ->
            $scope.loading = true
            HardSecuredService.convertToAutoRefinanceApplication()
              .then (newApplicationUrl) ->
                $modalInstance.close()
                $window.location.replace(newApplicationUrl)
              .finally ->
                $scope.loading = false

          $scope.edit = ->
            $scope.loading = true
            HardSecuredService.insufficientCollateralReply('retry')
              .then ->
                $scope.reset_vehicle_data [
                  'vin', 'mileage', 'year', 'make', 'model', 'series', 'style',
                  'free_and_clear', 'condition', 'additional_registered_owners',
                  'customer_confirmation'
                ]

                $scope.form.$setPristine()
                initVehicleDropdowns()
                $modalInstance.close()
              .finally ->
                $scope.loading = false

          $scope.decline = ->
            $scope.loading = true
            HardSecuredService.insufficientCollateralReply('cancel')
              .then ->
                CustomerApplicationService.createLoadingModal()
                $rootScope.$broadcast 'customer_application:modal_message', "Loading..."
                $window.location.reload()
              .finally ->
                $scope.loading = false
        ]

    initVehicleDropdowns = () ->
      # PageLoad
      #   Reset the stale vehicle lookup
      #   Perform a vehicle lookup if data is available
      $scope.vehicle_lookup = status: null
      performLookup()
      unless sufficientVehicleData()
        setDropdownsForVehicle()

    initVehicleDropdowns();

    $scope.reset_vehicle_data = (fields) ->
      $scope.vehicle_lookup = status: null

      for field in fields
        $scope["vehicle_#{field}s"] = null
        $scope.vehicle[field] = null
        $scope.update("vehicle.#{field}")

    $scope.vehicle_year_selected = ->
      $scope.reset_vehicle_data(['make', 'model', 'series', 'style'])

      HardSecuredService.drilldown({ year: $scope.vehicle.year }).then (makes) ->
        $scope.vehicle_makes = makes

    $scope.vehicle_make_selected = ->
      $scope.reset_vehicle_data(['model', 'series', 'style'])

      HardSecuredService.drilldown({ year: $scope.vehicle.year, make: $scope.vehicle.make }).then (models) ->
        $scope.vehicle_models = models

    $scope.vehicle_model_selected = ->
      $scope.reset_vehicle_data(['series', 'style'])

      payload = { year: $scope.vehicle.year, make: $scope.vehicle.make, model: $scope.vehicle.model }
      HardSecuredService.drilldown(payload).then (series) ->
        $scope.vehicle_series = series
        if !series?
          payload['series'] = $scope.vehicle.series
          HardSecuredService.drilldown(payload).then (styles) ->
            $scope.vehicle_styles = styles

    $scope.vehicle_series_selected = ->
      $scope.reset_vehicle_data(['style'])

      payload = { year: $scope.vehicle.year, make: $scope.vehicle.make, model: $scope.vehicle.model, series: $scope.vehicle.series }
      HardSecuredService.drilldown(payload).then (styles) ->
        $scope.vehicle_styles = styles

    $scope.vehicle_style_selected = ->
      performLookup()

    $scope.lookupVehicle = (callback) ->
      if vehicleChangedSinceLastLookup()
        performLookup(callback)

    $scope.vinChanged = ->
      $scope.reset_vehicle_data(['make', 'model', 'series', 'style'])
      $scope.vehicle.year = null

    HardSecuredService.getAutoLenders().then (lenders) ->
      $scope.autoLenders = _.each lenders, (lender) ->
        lender.label = "#{lender.lender_name} | Estimated balance: #{$filter("ProductMoney")(lender.current_balance_amount, $scope.config, 0)}"

      $scope.autoLenders.push(id: 'none', label: 'None of the above') if $scope.autoLenders

      if sufficientVehicleData()
        $scope.scrollToErrorPosition($("#vehicle-details-header").offset()?.top - 20, ->
          $('[name=vehicle_auto_lender]').focus();
        )

    $scope.hasAutoLenders = ->
      $scope.customer_application?.auto_refinance && !!$scope.autoLenders

    $scope.submit = ->
      if !($scope.vehicle?.vin || $scope.vehicle?.style)
        $scope.vehicle_lookup.status = 'required_lookup'
        _.first($('input.test-vehicle-vin')).focus()
        return

      $scope.$emit 'conversion:action', 'submit', 'vehicle'

      if isInPoorCondition() || (!isAutoRefinanceEnabled() && !isFreeAndClear())
        showInsufficientCollateralModal()
      else unless ($scope.isAutoRefinance() || isFreeAndClear())
        showAutoRefinanceModal()
      else
        $scope.submitWrapper (response_data) ->
          $scope.redirectIfDifferentPage response_data, ->
            if response_data.server_side_errors and response_data.server_side_errors.length > 0
              $scope.closeAllLoadingModals()
              $scope.showServerSideErrors(response_data.server_side_errors)
          true

    # controller lifecycle events
]
